import { Box, Stack, Typography } from '@mui/material';
import { _ } from '/@/locale';
import type { HelpArticleSection } from './markdown-sections';
import { useHelpArticleActiveSection } from './use-help-article-active-section';

const HelpCenterArticleSections = ({ sections }: { sections: HelpArticleSection[] }) => {
    const activeId = useHelpArticleActiveSection(sections);
    return (
        <Stack
            component='nav'
            aria-label={_('Secciones')}
            spacing={2}
            sx={{
                width: { xs: '100%', lg: 236 },
                flexShrink: 0,
                position: { lg: 'sticky' },
                top: { lg: 96 },
            }}
        >
            <Typography variant='h6' color='primary'>
                {_('Secciones')}
            </Typography>
            <Stack spacing={1}>
                {sections.map((s) => {
                    const active = s.id === activeId;
                    const nested = /^\d+\./.test(s.title.trim());
                    return (
                        <Box
                            key={s.id}
                            component='a'
                            href={`#${encodeURIComponent(s.id)}`}
                            aria-current={active ? 'location' : undefined}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                py: 1,
                                px: 2,
                                pl: nested ? 3 : 2,
                                borderLeft: active ? '2px solid' : '2px solid transparent',
                                borderColor: active ? 'secondary.main' : 'transparent',
                                textDecoration: 'none',
                                color: active ? 'secondary.main' : 'primary.main',
                                '&:hover': {
                                    color: 'secondary.main',
                                },
                                cursor: 'pointer',
                            }}
                        >
                            <Typography component='span' variant='body2' fontWeight={active ? 'bold' : 'normal'}>
                                {s.title}
                            </Typography>
                        </Box>
                    );
                })}
            </Stack>
        </Stack>
    );
};

export default HelpCenterArticleSections;
